import Team from '../../../../core/models/Team';

export default class TippingTeam extends Team {
	defaults() {
		return {
			...super.defaults,
			overall_rank:          '-',
			tipping_team_name:     '-',
			round_rank:            '-',
			total_points:          '-',
			margin:                '-',
			total_margin:          '-',
			avg_score:             '-',
			avg_last_round_score:  '-',
			avg_margin:            '-',
			avg_last_round_margin: '-'
		}
	}
}